import { RcClasses } from '../../../../foundation';
export var RcListClasses = RcClasses([], 'RcList');
